const updateLineScore = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        const { liveData: { linescore = {} } = {}, gameData: { teams = {}, status = {} } = {} } = action?.data || {};
        const linescoreTeams = linescore.teams || {};
        const isComplete = status?.abstractGameCode === 'F';
        let winner;
        if (isComplete) {
            const awayScore = linescoreTeams?.away?.runs;
            const homeScore = linescoreTeams?.home?.runs;
            if (awayScore > homeScore) {
                winner = 'away';
            } else if (homeScore > awayScore) {
                winner = 'home';
            }
        }

        const {
            inningHalf,
            scheduledInnings,
            currentInning,
            innings
        } = linescore;

        return {
            inningHalf,
            scheduledInnings,
            currentInning,
            innings,
            totalsData: linescoreTeams,
            awayAbbr: teams?.away?.abbreviation,
            homeAbbr: teams?.home?.abbreviation,
            awayTeamFull: teams?.away?.teamName,
            homeTeamFull: teams?.home?.teamName,
            complete: isComplete,
            winner
        };
    }

    return state;
};

export default updateLineScore;
